import styled from 'styled-components';

export const TextContainer = styled.div`
  margin-top: 25px;
  text-align: left;
`;

export const Label = styled.h5`
  color: ${(props) => props.theme.carvana.gray.dark};
  font-size: 16px;
`;

export const Text = styled.p`
  color: ${(props) => props.theme.carvana.gray.dark};
`;

export const Link = styled.a`
  color: ${(props) => props.theme.carvana.blue.primary};

  :hover {
    color: ${(props) => props.theme.carvana.blue.primary};
  }
`;
